if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          langList: this.querySelector('.js-lang-list'),
          langItems: Array.from(this.querySelectorAll(".js-lang-item"))
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        this.sortLanguages();
      }

      sortLanguages() {
        if (!this.elements.langList || this.elements.langItems === 0) { return; }

        const preferredOrder = ['en', 'ru', 'de', 'nl', 'it', 'fr', 'es', 'pl', 'uk'];
        let primaryLanguages = this.elements.langItems.filter((lang) => preferredOrder.includes(lang.getAttribute('data-lang')));
        const secondaryLanguages = this.elements.langItems.filter((lang) => !primaryLanguages.includes(lang));

        primaryLanguages = primaryLanguages.sort((a,b) => preferredOrder.indexOf(a.getAttribute('data-lang')) - preferredOrder.indexOf(b.getAttribute('data-lang')));

        const allLanguages = primaryLanguages.concat(secondaryLanguages);
        
        // Update elements' order in HTML, so screen readers and focus stay consistent. 
        this.elements.langList.append(...allLanguages);
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if(this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
